import { render } from "./detailProduct.vue?vue&type=template&id=2b8f9406&scoped=true"
import script from "./detailProduct.vue?vue&type=script&lang=js"
export * from "./detailProduct.vue?vue&type=script&lang=js"

import "./detailProduct.vue?vue&type=style&index=0&id=2b8f9406&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8f9406"]])

export default __exports__